<template>
	<div class="container">
		<div class="msgBox" @click="msgPop = !msgPop" v-if="userId">
			<div class="count" v-if="userInfo.wd_count">
				{{userInfo.wd_count > 10 ? '9' : userInfo.wd_count}}
			</div>
			<img class="msgIcon" src="../assets/msg.png" />
			消息
		</div>
		<div class="severBox" @click="severPop = true">
			<img class="severIcon" src="../assets/sever.png" />
			客服
		</div>
		<div class="severInfoPop" v-if="severPop">
			<div class="centerContent">
				<img class="sveerIcon" src="../assets/Home/sveerIcon.png" />
				<div class="email">
					客服邮箱：{{email}}
				</div>
				<div class="QQ">
					客服 QQ：{{qqNum}}
				</div>
				<div class="ok" @click="severPop = false">
					好的
				</div>
			</div>
		</div>
		<div class="msgPop" v-if="msgPop">
			<div class="topTitle">
				<div class="unread" v-if="userInfo.wd_count">
					未读消息
					<span>
						（{{userInfo.wd_count}}条）
					</span>
				</div>
				<div v-else></div>
				<div class="read" @click="readAllMsg">
					全部已读
				</div>
			</div>
			<div class="msgTypeList">
				<router-link :to="goToPostion(item)" class="msgType" v-for="(item,index) in msgTypeData" :key="index">
					<div class="msgTypeIconBox" @click="changeReadStatus(item)">
						<img class="msgTypeIcon" src="../assets/platformMsg.png" v-if="item.type == 3" />
						<img class="msgTypeIcon" src="../assets/activityMsg.png" v-if="item.type == 2" />
						<img class="msgTypeIcon" src="../assets/inMsg.png" v-if="item.type == 1" />
						<div class="redPoint" v-if="item.status == 2"></div>
					</div>
					<div class="msgTypeTitleBox" @click="changeReadStatus(item)">
						<div class="msgTypeTitle">{{item.type == 3 ? '平台公告' : item.type == 3 ? '活动通知' : '站内消息'}}</div>
						<div class="msgTypeContent ellipsis-1">
							{{item.content}}
						</div>
					</div>
				</router-link>
			</div>
			<router-link to="/msg-center?type=all" class="lookAll">
				查看全部信息>>
			</router-link>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'MsgSever',
		data() {
			return {
				email: '',
				qqNum: '',
				userId: '',
				userInfo: '',
				msgPop: false,
				severPop: false,
				msgTypeData: [{
					id: 3,
					title: '平台公告',
					content: '',
					isNewMsg: false,
					icon: require('@/assets/platformMsg.png')
				}, {
					id: 2,
					title: '活动通知',
					content: '',
					isNewMsg: false,
					icon: require('@/assets/activityMsg.png')
				}, {
					id: 1,
					title: '站内消息',
					content: '',
					isNewMsg: false,
					icon: require('@/assets/inMsg.png')
				}]
			}
		},
		created() {
			// 监听路由变化事件
			this.$router.afterEach(() => {
				this.hideMsgPop();
			});
		},
		mounted() {
			this.configData()
			if (localStorage.getItem('token')) {
				this.userId = localStorage.getItem('userId')
				this.userDetails()
			}
		},
		methods: {
			userDetails() {
				this.messageList()
				this.$api.post('/UserD/user_details', {}).then(res => {
					if (res.code == 1) {
						this.userInfo = res.data
						// this.msgTypeData[0].isNewMsg = this.userInfo.gg_wd_count != 0 ? true : false
						// this.msgTypeData[1].isNewMsg = this.userInfo.hd_wd_count != 0 ? true : false
						// this.msgTypeData[2].isNewMsg = this.userInfo.zn_wd_count != 0 ? true : false
						// this.msgTypeData[0].content = this.userInfo.gg_wd_last
						// this.msgTypeData[1].content = this.userInfo.hd_wd_last
						// this.msgTypeData[2].content = this.userInfo.zn_wd_last
					} else {
						console.log(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			changeReadStatus(item) {
				this.$api.post('/UserD/one_clear_message', {
					id: item.id,
				}).then(res => {
					console.log(res);
				}).catch(err => {
					console.log(err);
				})
			},
			goToPostion(item) {
				if (item.type == 1) {
					if (item.title == '站内通知>其他消息') {
						if (item.mb_id == 1) {
							//跳转积分列表
							return `/personal-center?menuId=11`
						} else if (item.mb_id == 2) {
							//跳转代金券
							return `/personal-center?menuId=9`
						}
					}
					if (item.title == '站内通知>积分订单消息') {
						return `/personal-center?menuId=15`
					}
					if (item.title == '站内通知>定制订单消息') {
						return `/order-details?type=2&orderId=${item.mb_id}`
					}
					if (item.title == '站内通知>花市订单消息') {
						return `/order-details?type=1&orderId=${item.mb_id}`
					}
					if (item.title == '站内通知>周边订单消息') {
						return `/order-details?type=3&orderId=${item.mb_id}`
					}
					if (item.title == '站内通知>动态消息') {
						return `/msg-super-talk-details?quId=${item.fq_id}&dtId=${item.dt_id}&id=${item.mb_id}`
					}
					if (item.title == '站内通知>群聊通知') {
						return `/personal-center?menuId=3&userId=${item.mb_id}&type=2`
					}
					if (item.title == '站内通知>私聊通知') {
						return `/personal-center?menuId=3&userId=${item.mb_id}`
					}
				} else {
					if (item.type == 2) {
						return `/activities-details?id=${item.mb_id}`
					} else if (item.type == 3) {
						return `/msg-details?id=${item.mb_id}`
					}
				}
			},
			messageList() {
				this.$api.post('/UserD/message_list', {
					p: 1,
					sf_type: 1,
					pagesize: 3,
					status: '',
					type: '',
				}).then(res => {
					if (res.code == 1) {
						this.msgTypeData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			naviToMagCenter(item) {
				this.$router.push({
					path: `/msg-center?type=${item.id}`
				})
			},
			readAllMsg() {
				this.$api.post('/UserD/clear_message', {}).then(res => {
					if (res.code == 1) {
						this.userDetails()
					} else {
						console.log(res.msg)
					}
				}).catch(err => {
					console.log(err);
				})
			},
			configData() {
				this.$api.post('/Other/config', {}).then(res => {
					if (res.code == 1) {
						res.data.forEach(item => {
							if (item.title == 'kf_email') {
								this.email = item.value
							}
							if (item.title == 'kf_qq') {
								this.qqNum = item.value
							}
						})
					}
				}).catch(err => {
					console.log(err);
				})
			},
			// 隐藏消息弹窗
			hideMsgPop() {
				this.msgPop = false;
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container {
		position: fixed;
		bottom: 3.5rem;
		right: .2rem;
		z-index: 100;
	}

	.msgBox {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: .48rem;
		height: .66rem;
		background: #E29358;
		border-radius: .05rem;
		font-weight: 400;
		font-size: .12rem;
		color: #252525;
		position: relative;
		cursor: pointer;

		.count {
			position: absolute;
			top: .04rem;
			right: .04rem;
			width: .16rem;
			height: .16rem;
			background: #FF0000;
			border: .01rem solid #FFFFFF;
			border-radius: 50%;
			font-weight: 500;
			font-size: .12rem;
			color: #FFFFFF;
			line-height: .12rem;
			text-align: center;
		}

		.msgIcon {
			margin-top: .04rem;
			margin-bottom: .04rem;
			width: .24rem;
			height: .22rem;
		}
	}

	.severBox {
		margin-top: .12rem;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: .48rem;
		height: .66rem;
		background: #EFD8B8;
		border-radius: .05rem;
		font-weight: 400;
		font-size: .12rem;
		color: #252525;
		cursor: pointer;

		.severIcon {
			margin-top: .04rem;
			margin-bottom: .04rem;
			width: .24rem;
			height: .22rem;
		}
	}

	.severInfoPop {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100vh;
		display: flex;
		align-items: center;
		justify-content: center;
		background: rgba(0, 0, 0, 0.5);
		z-index: 1;

		.centerContent {
			display: flex;
			flex-direction: column;
			width: 3.1rem;
			background: #FFFFFF;
			border-radius: .12rem;

			.sveerIcon {
				width: .64rem;
				height: .64rem;
				margin: .4rem auto 0;
			}

			.email,
			.QQ {
				margin-top: .24rem;
				margin-left: .24rem;
				font-weight: 500;
				font-size: .16rem;
				color: #252525;
			}

			.ok {
				margin: .24rem auto;
				width: 1.76rem;
				height: .36rem;
				background: #E29358;
				border-radius: .04rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				text-align: center;
				line-height: .36rem;
				cursor: pointer;
			}
		}
	}

	.msgPop {
		position: absolute;
		bottom: .76rem;
		right: 1rem;
		width: 3.22rem;
		height: 3.26rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		padding: .24rem .24rem 0;
		display: flex;
		flex-direction: column;

		.topTitle {
			display: flex;
			align-items: center;
			justify-content: space-between;
			margin-bottom: .09rem;

			.unread {
				display: flex;
				align-items: center;
				font-weight: 700;
				font-size: .16rem;
				color: #000000;
				line-height: .2rem;

				span {
					font-weight: 400;
					font-size: .12rem;
					color: #999999;
				}
			}

			.read {
				font-size: .14rem;
				color: #E29358;
				line-height: .2rem;
				cursor: pointer;
			}
		}

		.msgTypeList {
			display: flex;
			flex-direction: column;

			a:hover {
				text-decoration: none !important;
			}

			.msgType {
				margin-top: .15rem;
				display: flex;
				align-items: center;
				padding-bottom: .15rem;
				border-bottom: .02rem solid rgba(204, 204, 204, .4);
				cursor: pointer;

				.msgTypeIconBox {
					margin-right: .1rem;
					display: flex;
					align-items: center;
					position: relative;

					.msgTypeIcon {
						width: .36rem;
						height: .36rem;
					}

					.redPoint {
						position: absolute;
						top: 0;
						right: 0;
						width: .08rem;
						height: .08rem;
						border-radius: 50%;
						background: #FF0000;
						border: .01rem solid #FFFFFF;
					}
				}

				.msgTypeTitleBox {
					display: flex;
					flex-direction: column;

					.msgTypeTitle {
						font-weight: 500;
						font-size: .14rem;
						color: #333333;
					}

					.msgTypeContent {
						width: 2.2rem;
						font-weight: 400;
						font-size: .14rem;
						color: #666666;
					}
				}
			}
		}

		.lookAll {
			margin: .12rem auto;
			font-size: .14rem;
			color: #E29358;
			line-height: .2rem;
			cursor: pointer;
		}
	}
</style>